exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  background: rgba(25, 25, 25, 0.5); }\n  :host .modal-dialog {\n    margin-top: 0;\n    margin-right: 0;\n    margin-bottom: 0;\n    margin-left: 0;\n    position: absolute;\n    right: 0;\n    height: 100%;\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%); }\n  :host .modal-content {\n    width: 100%;\n    height: 100%;\n    border-top-style: solid;\n    border-top-color: #ddd;\n    border-top-width: 0;\n    border-bottom-style: solid;\n    border-bottom-color: #ddd;\n    border-bottom-width: 0;\n    border-radius: 0; }\n  :host .right .modal-content {\n    border-right-style: solid;\n    border-right-color: #ddd;\n    border-right-width: 0; }\n  :host.show .modal-dialog {\n    -webkit-transform: translateX(0);\n            transform: translateX(0); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/widgets/slide-in-modal/components/modal-window.component.scss
// module id = ../../../../../src/app/modules/widgets/slide-in-modal/components/modal-window.component.scss
// module chunks = main